import { useAppSelector } from 'hooks/reduxHooks'
import { getIsLuxPlusToursEnabled } from 'checkout/selectors/tourV2Selectors'
import { getIsEnabledFlightsLuxPlusPricingInCurrentRegion } from 'luxPlus/selectors/featureToggle'

interface LuxPlusMonthTakeoverEnabledVerticals {
  hotels: boolean
  tours: boolean
  flights: boolean
  experiences: boolean
}

// Same per-vertical gates used by the LuxPlus+ landing page's own offer carousels
// (LuxPlusLandingOfferCarousels), so the campaign carousels/chips stay consistent with what
// that page already considers available for LuxPlus+ pricing in the customer's region.
// Experiences isn't gated there either (ExperienceLuxPlusCarousel always renders), so it isn't here.
function useLuxPlusMonthTakeoverEnabledVerticals(): LuxPlusMonthTakeoverEnabledVerticals {
  const toursEnabled = useAppSelector(getIsLuxPlusToursEnabled)
  const flightsEnabled = useAppSelector(getIsEnabledFlightsLuxPlusPricingInCurrentRegion)

  return {
    hotels: true,
    tours: toursEnabled,
    flights: flightsEnabled,
    experiences: true,
  }
}

export default useLuxPlusMonthTakeoverEnabledVerticals
